import React from 'react';
import { LobsterRopelessGearToggle } from '../common/SliderControls/SliderControls';
import type { RegistryComponentProps } from '../../pages/registry/componentRegistry';
import { getRegistryData } from '../../pages/registry/componentRegistry';
import { useFormContextOptional } from '../../contexts/FormContext';

const SLUG = 'ropeless-gear-technology';
const SLUG_DB = 'ropeless-gear-technology-db';

interface RopelessGearTechnologyData {
  updatingParams?: boolean;
  fuelPriceUpdatingParams?: boolean;
  lobsterDisabled?: boolean;
}

export default function RopelessGearTechnology(props: RegistryComponentProps): React.ReactElement {
  const formContext = useFormContextOptional();
  const data = getRegistryData<RopelessGearTechnologyData>(props);

  const formValue = formContext?.values?.[SLUG] as boolean | undefined;
  const formDbValue = formContext?.values?.[SLUG_DB] as boolean | undefined;
  const ropelessGear = formValue ?? false;
  const dbRopelessGear = formDbValue ?? ropelessGear;
  const updatingParams =
    data.updatingParams ?? data.fuelPriceUpdatingParams ?? data.lobsterDisabled ?? false;

  const toggleRopelessGear = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const checked = e?.target?.checked ?? false;
      formContext?.setValue(SLUG, checked);
    },
    [formContext]
  );

  return (
    <LobsterRopelessGearToggle
      ropelessGear={ropelessGear}
      dbRopelessGear={dbRopelessGear}
      toggleRopelessGear={toggleRopelessGear}
      updatingParams={updatingParams}
    />
  );
}
